<template>
  <user-waveline-chart-card :chart-data="data"
              :chart-id="chartId"
              :chart-height="250"
              :chart-options="{ responsive: true, maintainAspectRatio: false }"
              :alertActive="data.anyAlertActive"
              chart-title="">
    <template slot="footer-title">
      {{ title }}
    </template>
    <template slot="footer-right">
<!--      <router-link v-if="link" :to="link">-->
        <p-button v-if="link" round class="mr-1 btn-team-member-list" type="primary" size="sm"
                  icon @click="clicked">
          <i v-if="icon" :class="icon" />
        </p-button>
<!--      </router-link>-->
    </template>
  </user-waveline-chart-card>
</template>

<script>
  import UserWavelineChartCard from 'src/components/UIComponents/Cards/UserWavelineChartCard'
  import { Badge, Button } from 'src/components/UIComponents'
  import { getBackgroundClass } from '../../../util/colors'

  export default {
    name: 'UserWavelineChart',
    components: {
      UserWavelineChartCard,
      Badge,
      [Button.name]: Button
    },
    props: {
      data: Object,
      title: String,
      badgeValue: [Number, String],
      icon: String,
      link: String
    },
    data () {
      return {
        chartId: `chart-id-${Date.now()}`
      }
    },
    methods: {
      getBackgroundClass,
        clicked() {
          this.$emit('clicked')
        }
    }
  }
</script>
